/**
 * JAZZ_ARCHETYPE
 *
 * Statistical profile for Jazz, Fusion, and Blues genres.
 * Focuses on harmonic complexity, improvisation (entropy), and swing/syncopation.
 */

import { ACTIVE_ARCHETYPE } from './BaseArchetype.js';

export const JAZZ_ARCHETYPE = {
    ...ACTIVE_ARCHETYPE,

    // Harmonic Rhythm: Fast (2 chords per bar often)
    harmonicRhythm: {
        ...ACTIVE_ARCHETYPE.harmonicRhythm,
        target: 0.5, // 2 chords per bar
        tolerance: 0.5
    },

    // Harmonic Consonance: Complex (Extensions are standard, not dissonant in context)
    // We treat "Consonance" broadly here, but allow lower scores for simple triads.
    harmonicConsonance: {
        ...ACTIVE_ARCHETYPE.harmonicConsonance,
        polarity: 'consonant', // But tailored for 7ths
        weight: 0.1
    },

    // Voice Distribution: Balanced, Piano/Brass focus
    voiceDistribution: {
        ...ACTIVE_ARCHETYPE.voiceDistribution,
        low: 0.2,
        mid: 0.5,
        high: 0.3,
        tolerance: 0.2,
        weight: 0.15
    },

    // Dynamic Range: Expressive (Ghost notes vs Accents)
    dynamicRange: {
        ...ACTIVE_ARCHETYPE.dynamicRange,
        minVariance: 0.25, // High variance (Ghost notes)
        targetVariance: 0.35
    },

    // Interval Entropy: High (Improvisational, chromaticism)
    intervalEntropy: {
        ...ACTIVE_ARCHETYPE.intervalEntropy,
        stepRatio: 0.5, // Balanced steps/skips
        weight: 0.25 // Important for "Jazz feel"
    },

    // Rhythmic Lock: Loose/Swing (Syncopated)
    // Note: Rhythmic Lock metric might need to handle "Ahead/Behind" beat in future.
    rhythmicLock: {
        ...ACTIVE_ARCHETYPE.rhythmicLock,
        weight: 0.1 // Lower weight, looseness is desired
    },

    motivicRepetition: {
        ...ACTIVE_ARCHETYPE.motivicRepetition,
        target: 0.4, // Lower repetition (Improv)
        weight: 0.1
    }
};
